/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useState } from 'react'
import { useAtom } from 'jotai'
import { Member } from '../models/Member'
import {
    sortBy,
    sortProperties,
    sortProperty,
    sortNotesBy,
    sortUpdatesBy,
} from '../utils/sortHelper'
import { sortedAtom, sortLock } from '../store/filter/filterAtom'
import { Note } from '../models/Note'
import { UpdateBatch } from '../models/UpdateBatch'

const useSortMembersList = () => {
    const [, setSortedAtom] = useAtom(sortedAtom)
    const [, setLock] = useAtom(sortLock)
    const [sortState, setSortState] = useState<sortProperty | undefined>(
        undefined
    )
    // const [sortedList, _setSortedList] = useState<
    //     Member[] | Note[] | UpdateBatch[]
    // >([])

    const setSort = (property: sortProperties): void => {
        setLock(false)
        if (sortState && sortState.property === property) {
            setSortState({
                direction:
                    sortState.direction === 'ascending'
                        ? 'descending '
                        : 'ascending',
                property,
            })
            setSortedAtom({
                direction:
                    sortState.direction === 'ascending'
                        ? 'descending '
                        : 'ascending',
                property,
            })
        } else {
            setSortState({
                direction: 'ascending',
                property,
            })
            setSortedAtom({
                direction: 'ascending',
                property,
            })
        }
    }

    // const setSortedList = (members: Member[]) => {
    //     if (sortState) {
    //         const list = sortBy(members, sortState)
    //         _setSortedList(list)
    //     } else {
    //         _setSortedList(members)
    //     }
    // }

    // const setSortedNoteList = (notes: Note[]) => {
    //     if (sortState) {
    //         const list = sortNotesBy(notes, sortState)
    //         _setSortedList(list)
    //     } else {
    //         _setSortedList(notes)
    //     }
    // }

    // const setSortedUpdatePageList = (updates: UpdateBatch[]) => {
    //     if (sortState) {
    //         const list = sortUpdatesBy(updates, sortState)
    //         _setSortedList(list)
    //     } else {
    //         _setSortedList(updates)
    //     }
    // }

    return {
        // sortedList,
        sortState,
        setSort,
        setSortState,
        // setSortedList,
        // setSortedNoteList,
        // setSortedUpdatePageList,
    }
}

export default useSortMembersList
